module.exports = {
  footerText: '© 2020 MCP Asset Management Company Limited',
}
